import React from "react";
import "pages/preliquidation/preliquidation.scss";
import TablePreliquidation from "./tablePreliquidation/TablePreliquidation";
import PreliquidationFilter from "./filter/PreliquidationFilterContainer";
import { PreliquidationsProps } from "./types";
import "./i18n";
import { useTranslation } from "react-i18next";
import { Button, HeaderDescription } from "@pickit/pickit-components";

export const Preliquidation: React.FC<PreliquidationsProps> = ({
  seeMore,
  preliquidations,
  getMorePreliquidations,
  anyPreliquidationSelected,
  sendToAccounting,
  approveInvoices,
  testId,
  getPreliquidationsExport,
  filters,
}): JSX.Element => {
  const { t } = useTranslation();
  const isExportDisabled = !filters.fiscalNumber && !filters.generatedAt && !filters.presettlementId && !filters.status && !filters.pickerId && !filters.documentationIncomplete;
  return (
    <>
      <div className="presettlements-title">
        <HeaderDescription
          headline={t("presettlements:presettlementsTitle")}
          overline="Administración"
          testId={`${testId}-title`}
        />
        <Button 
          disabled={isExportDisabled} 
          testId={testId}
          iconName="download"
          hierarchy="secondary"
          size="medium"
          label={t("global:export")}
          onClick={(e) => getPreliquidationsExport(filters, e.target)}
        />
      </div>
      <PreliquidationFilter testId="preliquidation-filter" />
      <div className="button-container-preliquidation">
        <Button
          label={t("presettlements:approveInvoices")}
          testId={`${testId}-aprove-invoices-button`}
          onClick={approveInvoices}
          size="medium"
          width="220"
        />
        <Button
          disabled={!anyPreliquidationSelected}
          testId={`${testId}-send-to-counting-button`}
          onClick={sendToAccounting}
          label={t("presettlements:sendToAccounting")}
          size="medium"
          width="220"
          hierarchy="secondary"
        />
      </div>
      <TablePreliquidation
        testId="table-preliquidation"
        items={preliquidations}
        seeMore={seeMore}
        getMorePreliquidations={getMorePreliquidations}
      />
    </>
  );
};
